<template>
  <div>
    <section class="faq vertical-scrolling">
      <div class="container">
        <div class="row">
          <div class="home-page-container col-md-9 col-sm-12">
            <div class="home-contain">
              <div class="text-white">
                <div class="contain">
                  <h1>
                    {{ $lang.about.common_questions_title }}
                  </h1>
                  <!-- <h4 class="slide-desc">
                    {{ $lang.about.convert_mp3_desc }}
                  </h4> -->

                  <!-- <button
                    type="button"
                    class="btn btn-custom btn-convert-mp3"
                    @click="onLogin"
                  >
                    {{ $lang.about.convert_mp3_now }}
                  </button>
                  <div class="convert-desc" style="color: #797676">
                    {{ $lang.about.convert_button_desc1 }} •
                    {{ $lang.about.convert_button_desc2 }}
                  </div> -->
                </div>
                <!-- <div
                  v-on:click="isHidden = !isHidden"
                  v-if="!isHidden"
                  :player-height="100"
                  class="white-popup"
                ></div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="seperator col-md-9 col-sm-12"></div>

        <div class="helpers-container col-md-9 col-sm-12">


          <div
          
            v-for="(faq, index) in faqItems"
            :key="index"
          class="row">
            <div class="faq-section col-md-12 col-sm-12">
              <h1 v-html="faq.title">{{ faq.title }}</h1>
              <span class="slide-desc" v-html="faq.desc">{{ faq.desc }}</span>
                <div class="play-button" v-show="!!faq.video">
                  <a v-on:click="onVideoClicked(faq.video)" class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
            </div>
          </div>

          <!-- <div class="row">
            <div class="col-md-9 col-sm-9">
              <h1>{{ $lang.about.question5 }}</h1>
            </div>

            <div class="col-md-3 col-sm-3">
              <div class="play-button">
                <a v-on:click="onVideoClicked('trim')" class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.png"' alt="play-button" class="img-fluid" /></a>
              </div>
            </div>
          </div> -->

          <!-- <div class="contain" style="position: relative">
            <button type="button" class="btn btn-custom back" @click="onHome">
              <v-icon left>fa fa-arrow-left</v-icon>{{ $lang.about.home }}
            </button>

            <button
              type="button"
              class="btn btn-custom btn-transcribe"
              @click="onLogin"
            >
              {{ $lang.about.transcribe_now }}
            </button>
          </div> -->

          <div
            v-on:click="isHidden = !isHidden"
            v-if="!isHidden"
            :player-height="100"
            class="white-popup"
          >
            <iframe width="560" height="315" :src="activeSrc" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
//import mediaUtils from "@/utils/mediaUtils";
export default {
  name: "MP4ToText",
  //   components: {
  //     About,
  //     Feature,
  //     UseCase
  //   },
  data() {
    return {
      isHidden: true,
      activeSrc: null,
      faqItems:[]
    };
  },
  metaInfo() {
    const me = this;
    return{
      title: me.$lang.about.common_questions_title,//me.$lang.about.taption,
      titleTemplate: '%s - Taption',

      meta: [
        { vmid: 'name', content: me.$lang.about.common_questions_title, itemprop: 'name' },
        { vmid: 'description', content: me.$lang.price.api_integration_tooltip.replace('{0}','10'), itemprop: 'description' },
        { vmid: 'article_desc', content: me.$lang.price.api_integration_tooltip.replace('{0}','10'), name: 'description' },
        { vmid: 'og_title', content: me.$lang.about.common_questions_title, property: 'og:title' },
        { vmid: 'og_desc', content: me.$lang.price.api_integration_tooltip.replace('{0}','10'), property: 'og:description' },
        { vmid:'twitter_title', content: me.$lang.about.common_questions_title, name: 'twitter:title' },
        { vmid:'twitter_desc',content: me.$lang.price.api_integration_tooltip.replace('{0}','10'), name: 'twitter:description' },
      ]
    }
  },
  methods: {
    onLogin() {
      const me = this;
      me.$router.push({ name: "login" });
    },
    onHome() {
      window.location.href = window.location.origin;
    },
    onVideoClicked(url) {
      const me = this;
      me.isHidden = !me.isHidden;
      me.activeSrc = url;
    },
  },
  mounted() {
    const me = this;

    for (var index in Array.from(Array(20))){
      const title = me.$lang.faq[`title_${index}`];
      const desc = me.$lang.faq[`desc_${index}`];
      const video = me.$lang.faq[`video_${index}`];
      const faq = {};
      if(title){
        faq.title = title;
        faq.desc = desc;
        faq.video = video;
        me.faqItems.push(faq);
      }

    }
    window.scrollTo(0, 0);
  },
  created() {
    const me = this;

    const preExisitingLang =
      me.$route.params.language ||
      window.localStorage.getItem("PrefferedLanguage");
    const language = preExisitingLang || "en-US";
    const displayLanguage = language;
    window.localStorage.setItem(
      "PrefferedLanguage",
      displayLanguage || "en-US"
    );
    me.$lang.setLang(displayLanguage || "en-US");
  },
};
</script>
<style scoped>
.seperator {
  margin: 0 auto;
}
</style>


<style>
.btn-custom.back {
  position: absolute;
  left: 0;
  top: 0;
  margin-top: 0px !important;
  background: #0062ff !important;
  padding: 10px 10px 10px 10px !important;
}
.helpers-container h1 {
  text-align: left !important;
}

.taption .faq,
.faq{
  background-image: url('../assets/images/about.webp')!important;
  background-repeat: repeat;
  /* background-image: url(/img/1.130a2cda.png); */
}

.faq .play-button {
  display:inline;
  margin-left:20px;
}

.faq .play-button img {
    position: absolute;
    display: block;
    bottom: -6px;
    left: -5px;
    z-index: 0;
    width: 40px;
    height: 40px;
    max-width: none;
}

.faq .animated-circle{
  position:relative;
}

.faq .animated-circle:before {
-webkit-box-shadow: 0 0 2px 5px #e8e8e8;
    box-shadow: 0 0 2px 7px #e8e8e8;
    position: absolute;
    content: "";
    width: 30px;
    height: 30px;
    bottom: auto;
    left: auto;
    border-radius: 50%;
    z-index: 0;
    -webkit-animation: none;
    animation: none;
}

.faq .btn-custom {
  margin-bottom: 0px !important;
}

.convert-desc {
  color: #797676;
  text-align: center;
}

.btn-transcribe,
.btn-convert-mp3 {
  height: 50px;
  width: 400px;
}

p {
  text-transform: none !important;
}

.blockquote {
  padding: 0px 0px;
  margin-bottom: 0px;
  border-left: 5px none #e2e2e2;
  font-size: 24px;
  line-height: 36px;
  font-weight: 300;
}

section {
  padding-bottom: 50px;
  padding-top: 0px;
  margin-top: 80px !important;
}

.helpers-container {
  margin: 0 auto;
}

.faq .home {
  min-height: auto !important;
  height: auto !important;
  padding-bottom: 0px;
}

.faq .slide-desc {
  color: #7f7f7f;
  font-size: 26px;
  line-height: 28px;
  font-weight: 300;
  width: 100% !important;
  text-transform: none !important;
  letter-spacing: 0px;
}

.faq .text-white {
  width: 100%;
}

.taption .faq h1,
.faq h1 {
  font-size: 40px;
  text-decoration: none;
  text-transform: none;
  font-weight: 400;
  line-height: 42px;
  letter-spacing: 0px;
  margin-top: 25px;
    margin-bottom: 40px;

}

.home-page-container {
  margin: 0 auto;
}
.faq-section{
  text-align: left;
}

.faq .contain .btn {
  margin: 0 auto;
  display: block;
  margin-top: 20px;
  margin-bottom: 30px;
  text-transform: initial;
  background: #3ccebd;
  font-size: 16px;
  height: 50px;
}

.faq .contain .btn:hover {
  background: #00e0c6;
}

.faq h1 {
  color: #1c2d27 !important;
  text-align: center;
}
.faq .home-contain h4 {
  color: #797676 !important;
  text-align: center;
}
.faq .home-contain p {
  color: #797676 !important;
  text-align: center;
  width: 50%;
  margin: 0 auto;
}

.faq .home-contain {
  margin-top: 10px;
  align-items: baseline;
  height: auto;
  width: 100%;
  background: #fafafa;
  background:transparent;
}

.intro-video {
  margin: 0px auto;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50px;
}

.landing-tooltip {
  z-index: 3;
  opacity: 1 !important;
  background: white !important;
  box-shadow: 0 1px 4px rgba(1, 1, 1, 0.15);
  color: #7f7f7f;
  font-size: 16px;
  padding: 10px;
}

.landing-tooltip .cell {
  margin: 10px 20px;
  text-align: left;
  width: 100px;
  display: table-cell;
}

.white-popup {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(93, 93, 93, 0.5);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 767px) {
  section.home {
    margin-top: 120px !important;
  }

  .faq .home-contain {
    display: contents;
  }
  .home h1 {
    margin-top: 20px !important;
    line-height: 24px;
  }

  .faq .slide-desc{
    font-size: 20px!important;
    line-height: 24px!important;
  }

  .faq .home-contain p {
    text-align: center;
    word-break: keep-all;

    width: 100%;
  }

  .faq h1 {
    line-height: 30px;
    font-size:26px!important;
  }

  .faq .animated-circle:before {
       bottom: -2px;
    left: 0px;
  }

  .faq .play-button img {
    bottom: -6px;
}

  /* button {
    width: auto !important;
  } */

  /* .faq .btn-transcribe {
    margin-right: 10px !important;
    margin-left: auto !important;
  } */
}
</style>
